import React from 'react'
import {
    OverContainer,
    ContentTypography,
    TypographySection,
    BoxContain,
    OverContainerSection,
    OverSpan,
    TypographySectionDes,
    ButtonSection,
    BoxForm,
} from './styles'
import { useAnimation } from 'src/hook'
import { rightVariant } from 'src/theme/animations/swipeIn'
import Button from 'src/components/common/Button'
import { LinkButton } from 'src/components/layout/Main/Header/styles'
import { useTranslations } from 'src/provider/LocaleProvider'
import { WaveEffect } from './WaveEffect'
import { ROUTES } from 'src/navigation'
import { SubscribeProps } from 'src/pages/BookACall/ContactForm'
import { FormData } from 'src/pages/BookACall/ContactForm/formData'

export function Hero(props: SubscribeProps) {
    const t = useTranslations()
    const { control, ref } = useAnimation({ initialSpriteIdTitle: 2 })
    const { setError, setEmailError, setCongratulations } = props

    return (
        <OverContainerSection>
            <OverContainer
                paddingTop={[
                    'xxxlarge',
                    'xxxlarge',
                    'xxxlarge',
                    'xxspacesFull',
                ]}
                marginBottom={['medium', 'medium', 'large', 'titlle']}
                width={1}
            >
                <OverSpan></OverSpan>
                <ContentTypography
                    paddingTop={['xlarge', 'xlarge', 'xmedium', 'xsixty']}
                    paddingBottom={['xmedium', 'xmedium', 'xmedium', 'xxsmall']}
                    marginBottom={[0, 0, 'xxlarge', 0]}
                    ref={ref}
                >
                    <BoxContain
                        paddingRight={[0, 0, 0, 'xxmedium']}
                        paddingLeft={[0, 0, 0, 'xxmedium']}
                        marginBottom={[
                            'xxmedium',
                            'xxmedium',
                            'xmedium',
                            'large',
                        ]}
                        marginTop={[0, 0, 0, -50]}
                        marginRight={[0, 0, 0, 'xlarge']}
                        initial="hidden"
                        animate={control}
                        variants={rightVariant}
                    >
                        <TypographySection
                            variant={'h1'}
                            fontSize={[
                                'xxxmedium',
                                'xxxmedium',
                                'xlarge',
                                'initial',
                            ]}
                            fontWeight={600}
                        >
                            {t('home.colombianSoftwareDevelopmentCompany')}
                        </TypographySection>

                        <TypographySectionDes
                            variant={'h2'}
                            fontSize={[
                                'xxxsmall',
                                'xxxsmall',
                                'medium',
                                'large',
                            ]}
                            fontWeight={400}
                        >
                            {t('home.agileApproach')}
                        </TypographySectionDes>
                        <ButtonSection paddingTop={['medium']}>
                            <LinkButton to={ROUTES.BOOK_A_CALL}>
                                <Button Content={t('cta.bookACall')} />
                            </LinkButton>
                        </ButtonSection>
                    </BoxContain>
                    <BoxForm>
                        <FormData
                            setCongratulations={setCongratulations}
                            setError={setError}
                            setEmailError={setEmailError}
                            width={'100%'}
                        />
                    </BoxForm>
                </ContentTypography>
            </OverContainer>
            <WaveEffect />
        </OverContainerSection>
    )
}
